import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Viewer from '../views/viewer/viewer'
Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/editor'
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: Home,
    //   children:[
    //     {
    //         path: '/viewer',
    //         name: 'viewer',
    //         component: Viewer
    //     },
    //     {
    //       path: '/demo1',
    //       name: 'demo1',
    //       component: () => import('../views/viewer/Demo1')
    //     },
    //     {
    //       path: '/translation',
    //       name: 'translation',
    //       component: () => import('../views/viewer/Translation')
    //     },
    //     {
    //       path: '/globeTransparent',
    //       name: 'globeTransparent',
    //       component: () => import('../views/viewer/GlobeTransparent')
    //     },
    //     {
    //       path: '/videoEnty',
    //       name: 'videoEnty',
    //       component: () => import('../views/viewer/VideoEnty')
    //     },
    //     {
    //       path: '/weather',
    //       name: 'weather',
    //       component: () => import('../views/viewer/Weather')
    //     },
    //     {
    //       path: '/czml',
    //       name: 'czml',
    //       component: () => import('../views/viewer/Czml')
    //     },
    //     {
    //       path: '/czmlEnty',
    //       name: 'czmlEnty',
    //       component: () => import('../views/viewer/CzmlEnty')
    //     },
    //     {
    //       path: '/entysTransform',
    //       name: 'entysTransform',
    //       component: () => import('../views/viewer/EntysTransform')
    //     },
    //     {
    //       path: '/layer',
    //       name: 'layer',
    //       component: () => import('../views/viewer/Layer')
    //     },
    //     {
    //       path: '/water',
    //       name: 'water',
    //       component: () => import('../views/viewer/Water')
    //     },
    //     {
    //       path: '/citybim',
    //       name: 'citybim',
    //       component: () => import('../views/viewer/Citybim')
    //     },
    //     {
    //       path: '/monomer',
    //       name: 'monomer',
    //       component: () => import('../views/viewer/Monomer')
    //     },
        
    //   ]
    // },
    // {
    //   path: '/canvas',
    //   name: 'canvas',
    //   component: () => import('../views/viewer/Canvas')
    // },
    {
      path: '/editor',
      name: 'Editor',
      component: () => import('../views/Editor.vue')
    },
    {
      path: '/editorr',
      name: 'editorr',
      component: () => import('../views/Editorr.vue')
    },
    {
      path: '/floor',
      name: 'floor',
      component: () => import('../views/Floor.vue')
    },
]

const router = new VueRouter({
  routes
})

export default router
